import { render, staticRenderFns } from "./newsEnt.vue?vue&type=template&id=afeae9d2&scoped=true&"
import script from "./newsEnt.vue?vue&type=script&lang=js&"
export * from "./newsEnt.vue?vue&type=script&lang=js&"
import style0 from "./newsEnt.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsEnt.vue?vue&type=style&index=1&id=afeae9d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeae9d2",
  null
  
)

export default component.exports